import { createAction } from 'redux-actions';
import { createActionBundle } from 'utilities/request';

export const {
  request: requestPractitioners,
  success: requestPractitionersSuccess,
  failure: requestPractitionersFailure,
} = createActionBundle('PRACTITIONERS');

export const {
  request: requestPractitionersGetByLogin,
  success: requestPractitionersGetByLoginSuccess,
  failure: requestPractitionersGetByLoginFailure,
} = createActionBundle('PRACTITIONERS/GET_BY_LOGIN');

export const {
  request: requestPractitionersCreate,
  success: requestPractitionersCreateSuccess,
  failure: requestPractitionersCreateFailure,
} = createActionBundle('PRACTITIONERS/CREATE');

export const practitionersAdd = createAction('PRACTITIONERS/ADD');
